'use client';

import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps, PrismicLink } from '@prismicio/react';

import { wrapperAlignment, button } from './cta.css';

export type CTAProps = SliceComponentProps<Content.CtaSlice>;

const CTA = ({ slice }: CTAProps): JSX.Element | null => {
  if (
    !isFilled.keyText(slice.primary.cta_label) ||
    !isFilled.link(slice.primary.cta_link)
  ) {
    return null;
  }

  const alignment = slice.primary.alignment || 'center';

  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundColor: isFilled.color(slice.primary.background_color)
          ? slice.primary.background_color
          : 'transparent',
      }}
      className={wrapperAlignment[alignment as 'left' | 'center']}
    >
      <PrismicLink field={slice.primary.cta_link} className={button}>
        {slice.primary.cta_label}
      </PrismicLink>
    </div>
  );
};

export default CTA;
